export default "__VITE_ASSET__75af04dc__"